import { LoadingState } from '@lcs/shared/api';
import { createFeatureSelector, on } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { RegisterState } from 'src/app/common-components/register/models/register-state';
import {
   RegisterAdapter,
   createRegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { accountIdChange } from 'src/app/store/select-account/select-account.actions';
import { BlockedPhoneNumberFilterOptions } from '../models/blocked-phone-number-filter-option';
import { BlockedPhoneNumberRegisterOptions } from '../models/blocked-phone-number-register-options';
import { BlockedPhoneNumberRegisterListItem } from '../models/blocked-phone-number-register-results.model';
import * as blockedPhoneNumberRegisterActions from './blocked-phone-number-register.actions';
import { blockedPhoneNumberRegisterAdapterActions } from './blocked-phone-number-register.actions';

export const blockedPhoneNumberRegisterFeatureKey = 'blockedPhoneNumberRegister';
export interface BlockedPhoneNumberRegisterState
   extends RegisterState<BlockedPhoneNumberRegisterListItem, BlockedPhoneNumberRegisterOptions, OrderingOption> {
   filters: BlockedPhoneNumberFilterOptions[];
}

const adapter: RegisterAdapter<BlockedPhoneNumberRegisterListItem, BlockedPhoneNumberRegisterOptions, OrderingOption> =
   createRegisterAdapter<BlockedPhoneNumberRegisterListItem, BlockedPhoneNumberRegisterOptions, OrderingOption>({
      selectId: (blockedPhoneNumberRegisterItem) => {
         return blockedPhoneNumberRegisterItem.blockedPhoneNumberId ?? 0;
      },
   });

const initialState: BlockedPhoneNumberRegisterState = {
   ...adapter.getInitialState(),
   filters: [],
};

export const blockedPhoneNumberRegisterReducer = adapter.createReducer(
   blockedPhoneNumberRegisterActions.blockedPhoneNumberRegisterAdapterActions,
   initialState,
   on(blockedPhoneNumberRegisterActions.blockedPhoneNumberRegisterAdapterActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(blockedPhoneNumberRegisterActions.blockedPhoneNumberRegisterAdapterActions.loadSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         endCursor: action.endCursor,
         hasNextPage: action.hasNextPage,
         blockedPhoneNumber: action.items,
         totalCount: action.totalCount,
      };
   }),
   on(blockedPhoneNumberRegisterActions.blockedPhoneNumberRegisterInitialFilter, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         filters: action.filters,
      };
   }),
   on(blockedPhoneNumberRegisterAdapterActions.quickFilterChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         quickFilters: {
            ...state.quickFilters,
            ...action.quickFilters,
         },
      };
   }),
   on(accountIdChange, (state, action) => {
      return {
         ...state,
         quickFilters: initialState.quickFilters,
      };
   })
);
export const blockedPhoneNumberRegisterSelector = createFeatureSelector<BlockedPhoneNumberRegisterState>(
   blockedPhoneNumberRegisterFeatureKey
);
export const selectors = adapter.getSelectors(blockedPhoneNumberRegisterSelector);
export const { selectAll, selectCallState, selectTotalCount, selectEndCursor, selectQuickFilters } =
   adapter.getSelectors(blockedPhoneNumberRegisterSelector);
